<template>
  <div class="page-container">
    <footer class="footer">
      <ul class="nav justify-content-center border-bottom pb-3 mb-3"></ul>
      <p class="text-center rf_texto">© {{ currentYear }} Deal Desk Systems</p>
    </footer>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const currentYear = ref(new Date().getFullYear());
</script>

<style scoped>
.page-container {
  display: flex;
  flex-direction: column;

}

</style>